export function mapEntityIdsToSet(entities) {
  return new Set(entities.map(e => e.id));
}
